module.exports = __webpack_public_path__ + "media/images/avatar/development/parents/17-ea864ee5eafbb9e6756bcab88a7bacd3.jpg";